import React, { Component } from 'react';
import { bool, string } from 'prop-types';
import { compose } from 'redux';
import { Form as FinalForm } from 'react-final-form';
import classNames from 'classnames';

import { FormattedMessage, injectIntl, intlShape } from '../../../util/reactIntl';
import { propTypes } from '../../../util/types';
import * as validators from '../../../util/validators';
import { Form, FieldTextInput, ExternalLink, Button } from '../../../components';
import { CONTACT_INFO } from '../../../helpers/enums';
import PhoneInput, { isValidPhoneNumber, formatPhoneNumberIntl } from 'react-phone-number-input';
import './phoneNumberInputGlobal.css';

import css from './ContactForm.module.css';
import { onSendEmail } from '../../../util/genericHelpers';

class ContactFormComponent extends Component {
  constructor(props) {
    super(props);
    this.state = {};
    this.setPhoneValue = this.setPhoneValue.bind(this);
    this.setInvalidPhoneValue = this.setInvalidPhoneValue.bind(this);
  }

  setPhoneValue(phone) {
    this.setState({ phoneValue: phone });
  }
  setInvalidPhoneValue(bool) {
    this.setState({ invalidPhoneNumber: bool });
  }

  render() {
    return (
      <FinalForm
        {...this.props}
        render={fieldRenderProps => {
          const {
            className,
            handleSubmit,
            intl,
            rootClassName,
            values,
            isGreek,
            invalid,
            inProgress,
            ready,
            onRedirectToAuth,
            form,
          } = fieldRenderProps;

          const changePhoneValue = () => {
            if (this.state.phoneValue) {
              form.change('phoneNumber', this.state.phoneValue);
              const formattedNumber = formatPhoneNumberIntl(this.state.phoneValue);
              if (isValidPhoneNumber(formattedNumber)) {
                this.setInvalidPhoneValue(false);
              } else {
                this.setInvalidPhoneValue(true);
              }
            } else {
              form.change('phoneNumber', null);
            }
          };

          // First name
          const firstNameLabel = intl.formatMessage({
            id: 'ContactForm.firstNameLabel',
          });
          const firstNamePlaceholder = intl.formatMessage({
            id: 'ContactForm.firstNamePlaceholder',
          });
          const firstNameRequiredMessage = intl.formatMessage({
            id: 'ContactForm.firstNameRequired',
          });
          const firstNameRequired = validators.required(firstNameRequiredMessage);

          // Email
          const emailLabel = intl.formatMessage({
            id: 'ContactForm.emailLabel',
          });
          const emailPlaceholder = intl.formatMessage({
            id: 'ContactForm.emailPlaceholder',
          });
          const emailRequiredMessage = intl.formatMessage({
            id: 'ContactForm.emailRequired',
          });
          const emailRequired = validators.required(emailRequiredMessage);

          const emailValid = validators.emailFormatValid(
            intl.formatMessage({
              id: 'SignupForm.emailInvalid',
            })
          );

          // Message
          const messageLabel = intl.formatMessage({
            id: 'ContactForm.messageLabel',
          });
          const messagePlaceholder = intl.formatMessage({
            id: 'ContactForm.messagePlaceholder',
          });

          const messageRequiredMessage = intl.formatMessage({
            id: 'ContactForm.messageRequired',
          });
          const messageRequired = validators.required(messageRequiredMessage);

          // Last name
          const lastNameLabel = intl.formatMessage({
            id: 'ContactForm.lastNameLabel',
          });
          const lastNamePlaceholder = intl.formatMessage({
            id: 'ContactForm.lastNamePlaceholder',
          });
          const lastNameRequiredMessage = intl.formatMessage({
            id: 'ContactForm.lastNameRequired',
          });
          const lastNameRequired = validators.required(lastNameRequiredMessage);

          const classes = classNames(rootClassName || css.root, className);

          const nameInputs = (
            <div className={css.formRow}>
              <div className={css.formFld}>
                <FieldTextInput
                  className={css.firstName}
                  type="text"
                  id="firstName"
                  name="firstName"
                  label={firstNameLabel}
                  // placeholder={firstNamePlaceholder}
                  validate={firstNameRequired}
                />
              </div>
              <div className={css.formFld}>
                <FieldTextInput
                  className={css.lastName}
                  type="text"
                  id="lastName"
                  name="lastName"
                  label={lastNameLabel}
                  // placeholder={lastNamePlaceholder}
                  validate={lastNameRequired}
                />
              </div>
            </div>
          );

          const emailInput = (
            <FieldTextInput
              className={css.lastName}
              type="text"
              id="email"
              name="email"
              label={emailLabel}
              // placeholder={emailPlaceholder}
              validate={validators.composeValidators(emailRequired, emailValid)}
            />
          );
          const messageInput = (
            <FieldTextInput
              className={css.lastName}
              type="textarea"
              id="message"
              name="message"
              label={messageLabel}
              // placeholder={messagePlaceholder}
              validate={messageRequired}
            />
          );

          return (
            <div className={css.contactFormContainer}>
              <div className={css.contactInfo}>
                <div>
                  <FormattedMessage id="ContactForm.email" />: {CONTACT_INFO.EMAIL}
                </div>
                <div>
                  <FormattedMessage id="ContactForm.phone" />: {CONTACT_INFO.PHONE}
                </div>
              </div>

              <div className={css.contentWidth}>
                <Form
                  className={classes}
                  onSubmit={e => {
                    this.submittedValues = values;
                    handleSubmit(e);
                  }}
                >
                  <div className={css.contactFormSection}>
                    {nameInputs}
                    <div className={css.formRow}>
                      <div className={classNames(css.formFld, css.fullWidth)}>{emailInput}</div>
                    </div>
                    <div className={css.formRow}>
                      <div className={classNames(css.formFld, css.fullWidth)}>
                        {' '}
                        <div className={css.name}>
                          <label>
                            {intl.formatMessage({
                              id: 'ContactForm.phoneNumberLabel',
                            })}{' '}
                          </label>
                          <PhoneInput
                            defaultCountry="GR"
                            id="phone"
                            value={this.state.phoneValue}
                            onChange={phone => this.setPhoneValue(phone)}
                            onMouseOut={changePhoneValue}
                            className={css.phoneNumber}
                          />

                          {this.state.invalidPhoneNumber && (
                            <div className={css.error}>
                              {' '}
                              {intl.formatMessage({
                                id: 'ContactForm.phoneNumberError',
                              })}
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                    <div className={css.formRow}>
                      <div className={classNames(css.formFld, css.fullWidth)}>{messageInput}</div>
                    </div>
                    <div className={css.submitForm}>
                      <Button
                        className={css.submitButton}
                        disabled={invalid}
                        inProgress={inProgress}
                        ready={ready}
                        type="submit"
                      >
                        <FormattedMessage id="ContactForm.saveChanges" />
                      </Button>
                    </div>
                  </div>
                </Form>
              </div>
            </div>
          );
        }}
      />
    );
  }
}

ContactFormComponent.defaultProps = {
  rootClassName: null,
  className: null,
  uploadImageError: null,
  updateProfileError: null,
  updateProfileReady: false,
};

ContactFormComponent.propTypes = {
  rootClassName: string,
  className: string,
  // from injectIntl
  intl: intlShape.isRequired,
};

const ContactForm = compose(injectIntl)(ContactFormComponent);

ContactForm.displayName = 'ContactForm';

export default ContactForm;
